import axios from "../utils/axios";

export const getAllAcademicTerms = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/academic-terms', { params });
    return data;
};

export const getAcademicTermsForSelect = async () => {
    const { data } = await axios.get('/academic-terms/for-select');
    return data;
};

export const getAcademicTerm = async (id) => {
    const { data } = await axios.get(`/academic-terms/${id}`);
    return data;
};

export const createAcademicTerm = async (req) => {
    const { data } = await axios.post('/academic-terms', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const updateAcademicTerm = async (req, id) => {
    const { data } = await axios.put(`/academic-terms/${id}`, req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAcademicTerm = async (id) => {
    const { data } = await axios.delete(`/academic-terms/${id}`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const deleteAllAcademicTerms = async (req) => {
    const { data } = await axios.delete('/academic-terms/mass-destroy', {
        data: req,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAcademicTerm = async (id) => {
    const { data } = await axios.delete(`/academic-terms/${id}/force-delete`, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const forceDeleteAllAcademicTerms = async (ids) => {
    const { data } = await axios.delete('/academic-terms/mass-force-delete', {
        data: ids,
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAcademicTerm = async (id) => {
    const { data } = await axios.post(`/academic-terms/${id}/restore`, {}, {
        headers: { Accept: 'application/json' },
    });
    return data;
};

export const restoreAllAcademicTerms = async (req) => {
    const { data } = await axios.post('/academic-terms/mass-restore', req, {
        headers: { Accept: 'application/json' },
    });
    return data;
};
